import React, { useState } from 'react';
import './ImageSlider.scss';

interface ImageSliderProps {
    images: string[];
    altText: string;
    isFavorite?: boolean;
    onFavoriteToggle?: () => void;
    onShareClick?: () => void;
}

export const ImageSlider: React.FC<ImageSliderProps> = ({
                                                            images,
                                                            altText,
                                                            isFavorite = false,
                                                            onFavoriteToggle = () => {},
                                                            onShareClick = () => {},
                                                        }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    if (!images.length) return null;

    return (
        <div className="image-slider">
            <div className="slider-container">
                {images.map((img, index) => (
                    <img
                        key={index}
                        src={img}
                        alt={`${altText} ${index + 1}`}
                        className={`slide ${index === currentIndex ? 'active' : ''}`}
                        loading="lazy"
                    />
                ))}
            </div>

            <button className="slider-top-button" onClick={onShareClick}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="12" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M19.0817 16.9499C14.1936 17.5016 10.4987 21.6348 10.4961 26.5539V27.1662C12.6205 24.607 15.7561 23.1028 19.0817 23.0475V26.2758C19.0818 26.7442 19.3495 27.1714 19.7711 27.3757C20.1926 27.5799 20.6938 27.5254 21.0615 27.2352L29.0548 20.9236C29.3386 20.6999 29.5042 20.3585 29.5042 19.9972C29.5042 19.6359 29.3386 19.2945 29.0548 19.0708L21.0615 12.7592C20.6938 12.469 20.1926 12.4144 19.7711 12.6187C19.3495 12.823 19.0818 13.2502 19.0817 13.7186V16.9499Z" stroke="#1B1D1D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            <button className="slider-bottom-button" onClick={onFavoriteToggle}>
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="12" fill="white"/>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23.7 12C26.87 12 29 14.98 29 17.76C29 23.39 20.16 28 20 28C19.84 28 11 23.39 11 17.76C11 14.98 13.13 12 16.3 12C18.12 12 19.31 12.91 20 13.71C20.69 12.91 21.88 12 23.7 12Z"
                        stroke={isFavorite ? "none" : "#1B1D1D"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill={isFavorite ? "#FB034F" : "white"}
                    />
                </svg>
            </button>

            {images.length > 1 && (
                <>
                    <button className="slider-arrow left" onClick={prevSlide}>
                        <span>‹</span>
                    </button>
                    <button className="slider-arrow right" onClick={nextSlide}>
                        <span>›</span>
                    </button>
                    <div className="slider-counter">
                        {currentIndex + 1}/{images.length}
                    </div>
                </>
            )}
        </div>
    );
};